import { render, staticRenderFns } from "./twofa.vue?vue&type=template&id=42988c06&scoped=true"
import script from "./twofa.vue?vue&type=script&lang=js"
export * from "./twofa.vue?vue&type=script&lang=js"
import style0 from "./twofa.vue?vue&type=style&index=0&id=42988c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42988c06",
  null
  
)

export default component.exports